import React from 'react';
import System from 'src/helper/system';

const BomWarningPopUp = (props) => {
    const { data, SetStatus } = props
    const { translation: t } = System;

    const onHide = () => {
        SetStatus(false)
        if (data.event) {
            data.event.target.value = null
        }
    };

    const onContinue = () => {
        data.warningCallBack()
        SetStatus(false)
    };

    return (
        <>
            <div className="avnet-modal modal-375">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => onHide()}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">{t('createANewBom')}</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="clearfix" />
                        <div className="mt-3 mb-3">
                            <>
                                <p className='mb-0 mt-3 text-center'>{t('newBomWillReplaceCurrentActiveBom')}<br />
                                    {t('doYouWantToContinue')}</p>
                            </>

                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145"
                                data-bs-toggle="modal"
                                data-bs-target="#RequestModal"
                                onClick={() => { onHide() }}>
                                {t('cancel')}
                            </button>
                            <button type="button" className="bs5 btn btn-primary btn-sm w145" data-bs-toggle="modal"
                                data-bs-target="#RequestModal"
                                onClick={() => onContinue()}>
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default BomWarningPopUp;